import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  splitPayments: 'Split Payments',
  splitPaymentssDescription:
    'Split payments into multiple transactions on your Zeller Terminal.',
})
